export const DEFAULT_DATE_FORMAT = 'YYYY-MM-DD';
export const DEFAULT_FULL_DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss';
export const RU_DOT_DATE_FORMAT = 'DD.MM.YYYY';
export const MONTH_YEAR_FORMAT = 'YYYY-MM';
export const FULL_MONTH_YEAR_FORMAT = 'MMMM YYYY';
export const FULL_MONTH_FORMAT = 'MMMM';
